$(function(){
  var promotion = false;
  if($('#promotion').length>0 && $('#promotion').hasClass('promotion-sticky')){
    //promotion = true;
    //var html = $('#promotion').html();
    //$('header.header').before(html);
  }

  function checkDots() {
    var dots = $('.slideshow-new .slideshow__content>.flickity-page-dots').html();
    if (dots) {
      // 元素存在
      clearInterval(interval); // 停止循环检测
      $('.slideshow__card>.flickity-page-dots').html(dots);

      $('.slideshow__card>.flickity-page-dots').each(function(){
        var num = $(this).attr('data-num') -1;
        $(this).find('.flickity-page-dot').eq(num).addClass('active');
      })
      
      $('.slideshow__card>.flickity-page-dots .flickity-page-dot').removeClass('is-selected');
    }else{
      
    }
  }
  if($('.slideshow-new').length>0){
    var interval = setInterval(checkDots, 500);
  }


  $('body').on('click', '.slideshow__card>.flickity-page-dots .flickity-page-dot', function(){
    var index = $(this).index();
    $('.slideshow-new .slideshow__content>.flickity-page-dots .flickity-page-dot').eq(index).click();

   // $('.slideshow__card').each(function(){
   //   $(this).find('.flickity-page-dot').eq(index).addClass('is-selected').siblings().removeClass('is-selected');
   // })

  })
  
  // if($('.slideshow-new').length>0){
  //   setTimeout(function(){
  //     var dots = $('.slideshow-new .slideshow__content>.flickity-page-dots').html();
  //     $('.slideshow__card>.flickity-page-dots').html(dots);
  //   }, 800)
  // }
  
 var pos;
 $(window).scroll(function(e){
    if(promotion){
      if($('#promotion').hasClass('show-all')){
        pos = 680;
      }else{
        pos = $('#promotion').offset().top + $('#promotion').height();
      }
      var h = $(this).scrollTop();
      if(h>pos){
        $('.shopify-section-header .fixed-holder').show(0, function(){
          $('.shopify-section-header .fixed-holder .promotion-holder').css({"top":0});
        });
        
      }else{
        $('.shopify-section-header .fixed-holder').hide(0, function(){
          $('.shopify-section-header .fixed-holder .promotion-holder').css({"top":"-100px"});
        });
      }
    }   
 });

})

$(document).ready(function () {
  const $blocks = $('main > .shopify-section');
  let $currentWrapper = null;

  $blocks.each(function () {
    const $block = $(this);

    if (
      $block.attr('id')?.includes('special_tab_seperator') ||
      $block.find('[id*="special_tab_seperator"]').length
    ) {
      $currentWrapper = $('<div class="column"></div>');
      $block.before($currentWrapper);
    }

    if ($currentWrapper) {
      $currentWrapper.append($block);
    }
  });

  $('.column').wrapAll('<div class="columns"></div>');
});


document.addEventListener('DOMContentLoaded', function () {
  var mobileMenu = document.getElementById('mobile-menu');
  if (!mobileMenu) return;
  mobileMenu.addEventListener('change', function () {
    var url = this.value;
    if (url) {
      window.location.href = url;
    }
  });
});

$(document).ready(function () {
  var mobileBreakpoint = 767;
  var $section     = $('.yakd-testimonial');
  var $heading     = $section.find('.banner__heading');
  var $subheading  = $section.find('.banner__subheading');
  var $overlay     = $section.find('.banner--overlay');
  var $placeholder = $('<div class="banner-text-placeholder"></div>');
  $placeholder.insertBefore($heading);

  function handleResize() {
    if ($(window).width() <= mobileBreakpoint) {
      $overlay.prepend($heading.add($subheading));
    } else {
      $placeholder.after($heading.add($subheading));
    }
  }
  handleResize();
  $(window).on('resize', handleResize);
});